import { render } from "./Pixabay.vue?vue&type=template&id=12eaa8c6"
import script from "./Pixabay.vue?vue&type=script&lang=js"
export * from "./Pixabay.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\babay\\Documents\\GitHub\\gosociali-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/Pixabay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12eaa8c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12eaa8c6', __exports__)) {
    console.log('reload')
    api.reload('12eaa8c6', __exports__)
  }
  
  module.hot.accept("./Pixabay.vue?vue&type=template&id=12eaa8c6", () => {
    console.log('re-render')
    api.rerender('12eaa8c6', render)
  })

}


export default __exports__